// src/components/HeadCommon.tsx
import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';

type HeadCommonProps = {
  title?: string;
  description?: string;
  noIndex?: boolean;
};

const DEFAULT_TITLE = 'autoChat AI';
const DEFAULT_DESCRIPTION = 'autoChat AI の管理コンソール';

const HeadCommon: React.FC<HeadCommonProps> = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content="noindex, nofollow" />
    <link rel="icon" href="/favicon.ico" />
  </Helmet>
);

export default HeadCommon;
